// extracted by mini-css-extract-plugin
export default {"layout":"OfferCard_layout__yC9O7","imgContainer":"OfferCard_imgContainer__VffXm","textContainer":"OfferCard_textContainer__VjXQp"};